import { useState } from "react";
import styles from "../styles/StepThree.module.css";
import CapsuleCounter from "./CapsuleCounter";

const StepThree = ({ setStep, formValues, setFormValues }) => {
    const handleChildIncrement0_12 = (val) => {
        setFormValues({ ...formValues, childSeatCount0_12: val });
    };
    const handleChildIncrement1_4 = (val) => {
        setFormValues({ ...formValues, childSeatCount1_4: val });
    };
    const handleChildIncrement4_12 = (val) => {
        setFormValues({ ...formValues, childSeatCount4_12: val });
    };

    const handleFlowerIncrement = (val) => {
        setFormValues({ ...formValues, flowersCount: val });
    };

    const handleChampIncrement = (val) => {
        setFormValues({ ...formValues, champagneCount: val });
    };
    const handleWeddingRibbon = (val) => {
        setFormValues({ ...formValues, weddingRibbonCount: val });
    };

    return (
        <div className="container">
            <nav className="container text-center">
                <img
                    className="img-fluid pt-4"
                    src="images/logo.svg"
                    alt="pegasus chauffeur"
                />
                <p className={`my-5 py-3 text-white ${styles.heading}`}>
                    Use the form below to check the pricing for our all
                    available vehicles. Smart, Secure, Online Payment System
                    designed for our valuable customers.
                </p>
            </nav>

            <img
                src="images/navigation-bar-step3.svg"
                alt="first step"
                className="img-fluid mb-5"
            />

            <div className={`${styles.box}`}>
                <h3 className={styles.extraHeading}>Add Extras</h3>
                <p className={styles.desc}>Select Extra Options</p>
                <div className={`${styles.greyBox} my-2`}>
                    <div className="row">
                        <div className={"col-lg-8 my-auto"}>
                            <p className={styles.extraItem}>
                                <strong>Child Seat - </strong>Baby car seat for
                                children{" "}
                            </p>
                        </div>
                        <div className="col-lg-4 my-auto">
                            <div className={`${styles.smallWhiteBox}`}>
                                <div className="row">
                                    <div className="col">
                                        <h5 className={styles.price}>£25.00</h5>
                                        {/* <CapsuleCounter
                                            increment={
                                                formValues.childSeatCount
                                            }
                                            setIncrement={handleChildIncrement}
                                        /> */}
                                    </div>
                                    <div className="col my-auto">
                                        {formValues.childSeatSelected ? (
                                            <button
                                                className={styles.selectedBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            childSeatSelected:
                                                                !prevState.childSeatSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Selected{" "}
                                                <img
                                                    src="images/checkmark-24.png"
                                                    alt="Checked"
                                                    className="img-fluid mx-2 my-auto"
                                                    width={15}
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                className={styles.selectBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            childSeatSelected:
                                                                !prevState.childSeatSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Select
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {formValues.childSeatSelected ? (
                            <div>
                                <label className={styles.formLabel}>
                                    Please Enter Age of the Child (months){" "}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="row justify-content-between">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <li
                                            className={`${styles.ChildSeatLabel} ${styles.tooltip}`}
                                        >
                                            Age from 0-3
                                            <img
                                                src="images/child0-3.jpeg"
                                                alt=""
                                                className={styles.tooltipimgs}
                                            />
                                        </li>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-3 mt-3">
                                        <CapsuleCounter
                                            increment={
                                                formValues.childSeatCount0_12
                                            }
                                            setIncrement={
                                                handleChildIncrement0_12
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <li
                                            className={` ${styles.ChildSeatLabel} ${styles.tooltip}`}
                                        >
                                            Age from 4-6
                                            <img
                                                src="images/child3-6.jpeg"
                                                alt=""
                                                className={styles.tooltipimgs}
                                            />
                                        </li>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-3 mt-3">
                                        <CapsuleCounter
                                            increment={
                                                formValues.childSeatCount1_4
                                            }
                                            setIncrement={
                                                handleChildIncrement1_4
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <li
                                            className={` ${styles.ChildSeatLabel} ${styles.tooltip}`}
                                        >
                                            Age from 6-12
                                            <img
                                                src="images/child6-12.jpeg"
                                                alt=""
                                                className={styles.tooltipimgs}
                                            />
                                        </li>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-3 mt-3">
                                        <CapsuleCounter
                                            increment={
                                                formValues.childSeatCount4_12
                                            }
                                            setIncrement={
                                                handleChildIncrement4_12
                                            }
                                        />
                                    </div>
                                </div>

                                {/* <input
                                    className={styles.formInput}
                                    type="number"
                                    value={formValues.childSeatAge}
                                    onChange={(e) =>
                                        setFormValues({
                                            ...formValues,
                                            childSeatAge: e.target.value,
                                        })
                                    }
                                /> */}
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                <div className={`${styles.greyBox} my-2`}>
                    <div className="row">
                        <div className="col-lg-8 my-auto">
                            <p className={styles.extraItem}>
                                <strong>Bouquet of Flowers - </strong>A bouquet
                                of seasonal flowers prepared by a local florist
                            </p>
                        </div>
                        <div className="col-lg-4 my-auto">
                            <div className={`${styles.smallWhiteBox}`}>
                                <div className="row">
                                    <div className="col">
                                        <h5 className={styles.price}>£25.00</h5>
                                        <CapsuleCounter
                                            increment={formValues.flowersCount}
                                            setIncrement={handleFlowerIncrement}
                                        />
                                    </div>
                                    <div className="col my-auto">
                                        {formValues.flowersSelected ? (
                                            <button
                                                className={styles.selectedBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            flowersSelected:
                                                                !prevState.flowersSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Selected{" "}
                                                <img
                                                    src="images/checkmark-24.png"
                                                    alt="Checked"
                                                    className="img-fluid mx-2 my-auto"
                                                    width={15}
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                className={styles.selectBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            flowersSelected:
                                                                !prevState.flowersSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Select
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.greyBox} my-2`}>
                    <div className="row">
                        <div className="col-lg-8 my-auto">
                            <p
                                className={`${styles.extraItem} ${styles.champagneTooltip}`}
                            >
                                <strong>Champagne - </strong> French Champagne
                                Brut 0.75l Bottle
                                <img
                                    className={styles.tooltipChampagneImg}
                                    src="images/champange.jpeg"
                                    alt="Champagne"
                                />
                            </p>
                        </div>
                        <div className="col-lg-4 my-auto">
                            <div className={`${styles.smallWhiteBox}`}>
                                <div className="row">
                                    <div className="col">
                                        <h5 className={styles.price}>£25.00</h5>
                                        <CapsuleCounter
                                            increment={
                                                formValues.champagneCount
                                            }
                                            setIncrement={handleChampIncrement}
                                        />
                                    </div>
                                    <div className="col my-auto">
                                        {formValues.champagneSelected ? (
                                            <button
                                                className={styles.selectedBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            champagneSelected:
                                                                !prevState.champagneSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Selected{" "}
                                                <img
                                                    src="images/checkmark-24.png"
                                                    alt="Checked"
                                                    className="img-fluid mx-2 my-auto"
                                                    width={15}
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                className={styles.selectBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            champagneSelected:
                                                                !prevState.champagneSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Select
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.greyBox} my-2`}>
                    <div className="row">
                        <div className="col-lg-8 my-auto">
                            <p
                                className={`${styles.extraItem}`}
                                // className={`${styles.extraItem} ${styles.WeddingRibbonTooltip}`}
                            >
                                <strong>Wedding Ribbon - </strong> A classy
                                looking car ribbon can completely transform your
                                wedding transport.
                                {/* <img
                                    className={styles.tooltipWeddingRibbonImg}
                                    src="./images/wedding_Car.png"
                                    alt=""
                                /> */}
                            </p>
                        </div>
                        <div className="col-lg-4 my-auto">
                            <div className={`${styles.smallWhiteBox}`}>
                                <div className="row gy-3">
                                    <div className="col">
                                        <h5 className={styles.price}>£25.00</h5>
                                    </div>
                                    <div className="col my-auto">
                                        {formValues.weddingRibbonSelected ? (
                                            <button
                                                className={styles.selectedBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            weddingRibbonSelected:
                                                                !prevState.weddingRibbonSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Selected{" "}
                                                <img
                                                    src="images/checkmark-24.png"
                                                    alt="Checked"
                                                    className="img-fluid mx-2 my-auto"
                                                    width={15}
                                                />
                                            </button>
                                        ) : (
                                            <button
                                                className={styles.selectBtn}
                                                onClick={() =>
                                                    setFormValues(
                                                        (prevState) => ({
                                                            ...prevState,
                                                            weddingRibbonSelected:
                                                                !prevState.weddingRibbonSelected,
                                                        })
                                                    )
                                                }
                                            >
                                                Select
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row gy-3 pb-5">
                <div className="col-sm-12 col-md-6 text-center order-md-0 order-1">
                    <button
                        className={`${styles.previousBtn}`}
                        onClick={() => setStep(2)}
                    >
                        Go to Previous Page
                    </button>
                </div>
                <div className="col-sm-12 col-md-6 text-center order-md-1 order-0">
                    <button
                        className={`${styles.nextBtn}`}
                        onClick={() => setStep(4)}
                    >
                        Go to Details Page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StepThree;
